import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRoutes } from 'config/api/apiRoutes';
import { LIST_DEFAULT_STALE_TIME } from 'utils/setting';
import { INumberFormData } from 'models/whatsAppNumberModel';
import { useWhatsAppNumberApi } from './whatsAppNumberApi';

export const useGetWhatsAppNumbers = (enabled: boolean = true) => {
    const { getWhatsAppNumberList } = useWhatsAppNumberApi();

    const query = useQuery([apiRoutes.getWhatsAppNumbers], () => getWhatsAppNumberList(), {
        staleTime: LIST_DEFAULT_STALE_TIME,
        enabled: enabled
    });

    return query
}

export const useGetWhatsAppNumbersByStatusIds = (senderIds : Array<number>) => {
    const { getWhatsAppNumberListByStatusIds } = useWhatsAppNumberApi();

    const query = useQuery([apiRoutes.getWhatsAppNumbersByStatusIds], () => getWhatsAppNumberListByStatusIds(senderIds), {
        staleTime: 0
    });

    return query
}

export const useCreateWhatsAppNumber = () => {
    const { createWhatsAppNumber } = useWhatsAppNumberApi();

    const mutation = useMutation((data: INumberFormData) => createWhatsAppNumber(data), {
    })

    return mutation
}

export const useVerifyWhatsAppNumber = () => {
    const { verifyWhatsAppNumber } = useWhatsAppNumberApi();

    const queryClient = useQueryClient();

    const mutation = useMutation((data: { phoneNumberId: string, verificationCode: string }) => verifyWhatsAppNumber(data.phoneNumberId, data.verificationCode), {
        onSuccess: (newData) => {
            queryClient.invalidateQueries([apiRoutes.getWhatsAppNumbers])
        },
    })

    return mutation
}

export const useRequestWhatsAppNumberVerification = () => {
    const { requestWhatsAppNumberVerificationCode } = useWhatsAppNumberApi();

    const mutation = useMutation((data: { phoneNumberId: string }) => requestWhatsAppNumberVerificationCode(data.phoneNumberId), {
    })

    return mutation
}

export const useSyncWhatsAppNumbers = () => {
    const { syncNumbers } = useWhatsAppNumberApi();

    const queryClient = useQueryClient();

    const [isLoading, setLoading] = useState<boolean>(false)

    const syncNumbersAsync = async () => {
        setLoading(true)
        return syncNumbers()
            .then(res => {
                queryClient.invalidateQueries({ queryKey: [apiRoutes.getWhatsAppNumbers] })
                return true
            })
            .catch((error) => false)
            .finally(() => setLoading(false))
    }

    return { syncNumbersAsync, isLoading }
}